import NavBar from "./NavBar";
import "./css/components.css";

export default function Layout({ children, ...props }) {
  return (
    <article {...props}>
      <header>
        <NavBar />
      </header>
      <main>{children}</main>
    </article>
  );
}
